import { InfoCircleOutlined } from "@ant-design/icons";
import { t } from "@lingui/macro";
import { Tooltip } from "antd";
import Card from "antd/lib/card";
import { FC } from "react";
import { BaseComponentProps } from "types";
import AnimatedNumber from "./AnimatedCounter";
import "./TotalReportSection.scss";

interface Props extends BaseComponentProps {
	totalRevenue?: string;
	totalSoldCar?: string;
	totalEnabledMerchant?: string;
	totalEnabledCustomer?: string;
	totalPublishCars?: string;
	totalPublishPrice?: string;
}

const TotalReportSection: FC<Props> = ({
	totalRevenue,
	totalSoldCar,
	totalEnabledMerchant,
	totalEnabledCustomer,
	totalPublishCars,
	totalPublishPrice,
}) => (
	<div className="gap-5 grid grid-cols-4">
		<Card>
			<div className="flex items-center">
				{t`Total revenue`}
				<Tooltip
					className="ml-3"
					showArrow={false}
					placement="right"
					overlayClassName="report-total-tooltip-overlay"
					title={t`Total value of cars and services sold by Liberty Carz`}
				>
					<InfoCircleOutlined />
				</Tooltip>
			</div>
			<AnimatedNumber number={parseInt(totalRevenue ?? "0")} isPrice={true} />
		</Card>
		<Card>
			<div className="flex items-center">
				{t`Total sold cars`}
				<Tooltip
					className="ml-3"
					showArrow={false}
					placement="right"
					overlayClassName="report-total-tooltip-overlay"
					title={t` Total cars sold by Liberty Carz`}
				>
					<InfoCircleOutlined />
				</Tooltip>
			</div>
			<AnimatedNumber number={parseInt(totalSoldCar ?? "0")} />
		</Card>
		<Card>
			<div className="flex items-center">
				{t`Total Enable Merchant`}
				<Tooltip
					className="ml-3"
					showArrow={false}
					placement="right"
					overlayClassName="report-total-tooltip-overlay"
					title={t` Total enabled merchant accounts on Merchant App`}
				>
					<InfoCircleOutlined />
				</Tooltip>
			</div>
			<AnimatedNumber
				number={parseInt(totalEnabledMerchant ?? "0")}
			/>
		</Card>
		<Card>
			<div className="flex items-center">
				{t`Total Enable Customer`}
				<Tooltip
					className="ml-3"
					showArrow={false}
					placement="right"
					overlayClassName="report-total-tooltip-overlay"
					title={t`Total enabled customer accounts on Customer App`}
				>
					<InfoCircleOutlined />
				</Tooltip>
			</div>
			<AnimatedNumber
				number={parseInt(totalEnabledCustomer ?? "0")}
			/>
		</Card>
		<Card>
			<div className="flex items-center">
				{t`Total number of publish cars`}
				<Tooltip
					className="ml-3"
					showArrow={false}
					placement="right"
					overlayClassName="report-total-tooltip-overlay"
					title={t`The number of cars with Publish status`}
				>
					<InfoCircleOutlined />
				</Tooltip>
			</div>
			<AnimatedNumber number={parseInt(totalPublishCars ?? "0")} />
		</Card>
		<Card>
			<div className="flex items-center">
				{t`Total publish car value`}
				<Tooltip
					className="ml-3"
					showArrow={false}
					placement="right"
					overlayClassName="report-total-tooltip-overlay"
					title={t`Total price of cars with Publish status`}
				>
					<InfoCircleOutlined />
				</Tooltip>
			</div>
			<AnimatedNumber number={parseInt(totalPublishPrice ?? "0")} isPrice={true} />
		</Card>
	</div>
);

export default TotalReportSection;
